// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","logoFooter":"Footer_logoFooter__M+RNF","textFooter":"Footer_textFooter__SdHUD"};